//@flow

import React from 'react';
import capitalize from 'lodash/capitalize';

import type { SightingData } from './../../types/cards';
import { HGCardBase, Description, CardBodyBottom, CardBodyTop } from './Common';
import AddBtnMobile from './Common/AddBtnMobile';

type Props = {
  handleCardClick: Function,
  editable: Object,
  cardData: SightingData,
};

export default function SightingCard(props: Props) {
  const { cardData, editable, handleCardClick } = props;
  const { summary, name, categories } = cardData;

  return (
    <HGCardBase
      className="sightingCard"
      editable={editable}
      cardData={cardData}
      onClick={handleCardClick}
    >
      <CardBodyTop title={name} onClick={handleCardClick} type="sighting">
        <Description description={summary ? summary : ''} />
        <AddBtnMobile editable={editable} cardData={cardData} />
      </CardBodyTop>

      <CardBodyBottom>
        <p className="category">{categories && <span>{capitalize(categories[0])}</span>}</p>
      </CardBodyBottom>
    </HGCardBase>
  );
}



// WEBPACK FOOTER //
// ./src/components/Cards/SightingCard.jsx